import { useId } from 'react';
import { Link } from 'react-router';
import { Checkbox } from '@/components/ui/checkbox';
import { LEGAL_ROUTES } from './legal.config';

/** “Li e aceito…” com links para os Termos e a Política (abrem em nova aba, para não perder o formulário). */
export function TermsCheckbox({ checked, onCheckedChange, error }: { checked: boolean; onCheckedChange: (checked: boolean) => void; error?: string }) {
  const uid = useId();
  const id = `terms${uid.replace(/:/g, '')}`;
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-start gap-3">
        <Checkbox id={id} checked={checked} onCheckedChange={(v) => onCheckedChange(v === true)} aria-invalid={error ? true : undefined} aria-describedby={error ? `${id}-error` : undefined} className="mt-0.5" />
        <label htmlFor={id} className="text-sm leading-relaxed">
          Li e aceito os{' '}
          <Link to={LEGAL_ROUTES.terms} target="_blank" rel="noopener noreferrer" className="font-medium text-primary underline-offset-4 hover:underline">
            Termos de Uso
          </Link>{' '}
          e a{' '}
          <Link to={LEGAL_ROUTES.privacy} target="_blank" rel="noopener noreferrer" className="font-medium text-primary underline-offset-4 hover:underline">
            Política de Privacidade
          </Link>
          <span aria-hidden className="ml-0.5 text-destructive">
            *
          </span>
        </label>
      </div>
      {error && (
        <p id={`${id}-error`} role="alert" className="text-xs font-medium text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}
